import {
  useWhatIfPositions,
  whatIfEditMode,
} from "@iliotech/data-wire/src/stores";
import {
  NumericTextBox,
  NumericTextBoxChangeEvent,
} from "@progress/kendo-react-inputs";
import { WhatIfPositionsTableCellProps } from "../WhatIfPositionsTable";
import { observer } from "mobx-react-lite";
import classNames from "classnames";
import s from "./Cells.module.scss";
import { MdLock, MdLockOpen } from "react-icons/md";
const QuantityCell = ({ index }: WhatIfPositionsTableCellProps) => {
  const store = useWhatIfPositions();
  const quantity = store.getField<number>("quantity", index);
  const editMode = store.editMode;
  const disabled = !quantity;
  const onChange = (event: NumericTextBoxChangeEvent) => {
    store.onRowQuantityChange(index, event?.value || 0);
  };
  const fixed = store.getField<boolean>("fixed", index);
  const updateFixed = () => {
    store.onToggleFixed(index);
  };
  if (editMode === whatIfEditMode.QUANTITY) {
    return (
      <div className={s.quantityWrapper}>
        <NumericTextBox
          placeholder="Enter quantity"
          name={"quantity"}
          value={quantity || 0}
          format={{
            maximumFractionDigits: 7,
          }}
          className={classNames(disabled && s.disabled)}
          spinners={false}
          onChange={onChange}
        />
        <div onClick={updateFixed} className={s.lockIconWrapper}>
          {!!fixed ? (
            <MdLock className={s.lockIcon} />
          ) : (
            <MdLockOpen className={s.lockIcon} />
          )}
        </div>
      </div>
    );
  }

  const formattedValue = quantity
    ? quantity.toLocaleString(undefined, {
        maximumFractionDigits: 0,
      })
    : "";

  return <span>{formattedValue || 0}</span>;
};

export default observer(QuantityCell);
